<template>
    <el-dialog
      custom-class="real-dialog"
      :visible="dialogVisible"
      width="80%"
      center
      top="20px"
      @close="handleClose"
      append-to-body
    >
      <div style="line-height: 3; font-size: 18px;">相机监控</div>
      <el-table
        :data="cameraData"
        border
        max-height="300px"
        style="width: 100%">
        <el-table-column
          prop="SerialNo"
          align="center"
          label="相机序列号">
        </el-table-column>
        <el-table-column
          prop="FactoryName"
          align="center"
          label="相机品牌">
        </el-table-column>
        <el-table-column
          prop="Name"
          align="center"
          label="相机名称">
        </el-table-column>
        <el-table-column
          prop="MngIp"
          align="center"
          label="相机IP">
        </el-table-column>
        <el-table-column
          prop="OnlineStateStr"
          align="center"
          label="相机状态">
        </el-table-column>
        <el-table-column
          prop="OutLineTime"
          align="center"
          label="离线时间">
        </el-table-column>
        <el-table-column
          prop="ParkLotGateName"
          align="center"
          label="所属出入口">
        </el-table-column>
      </el-table>
      <div style="line-height: 3; padding-top: 20px; font-size: 18px;">盒子监控</div>
      <el-table
        :data="boxData"
        border
        max-height="300px"
        style="width: 100%">
        <el-table-column
          prop="Number"
          align="center"
          label="盒子编号">
        </el-table-column>
        <el-table-column
          prop="SerialNumber"
          align="center"
          label="盒子序列号">
        </el-table-column>
        <el-table-column
          prop="Name"
          align="center"
          label="盒子名称">
        </el-table-column>
        <el-table-column
          prop="Ip"
          align="center"
          label="盒子IP">
        </el-table-column>
        <el-table-column
          prop="OnlineStateStr"
          align="center"
          label="盒子状态">
        </el-table-column>
        <el-table-column
          prop="OutLineTime"
          align="center"
          label="离线时间"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="关联出入口名称"
          width="250px"
        >
          <template slot-scope="scope">
            <el-popover
              placement="top"
              width="400"
              trigger="hover">
              <div v-for="(v, i) in scope.row.ParkLotGateNameArr" :key="i">{{v}}</div>
              <div slot="reference">{{scope.row.ParkLotGateNameArr[0]}}</div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
</template>

<script>
import showdialog from '@/minxs/showdialog'
import { queryParkLotGateCam, queryParkLotBoxInfo, queryCamFactory } from "@/api/module/park";

export default {
  components: {
  },
  props: {
  },
  mixins:[showdialog],
  data() {
    return {
      cameraData: [],
      boxData: [],
      sentryId: undefined,
      factoryOptions: [],
    };
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.sentryId = Number(sessionStorage.getItem("sentryId"));
    this.queryCamFactory();
    this.queryParkLotGateCam();
    this.queryParkLotBoxInfo();
  },
  methods: {
    queryParkLotGateCam() {
      queryParkLotGateCam({SentryId: this.sentryId}).then(res => {
        if (res.state === "success") {
          this.cameraData = res.data.map(v => {
            v.OnlineStateStr = v.OnlineState ? '在线' : '离线';
            let arr = this.factoryOptions.filter(val => {return val.Factory === v.Factory});
            v.FactoryName = arr[0].Name;
            return v
          });
        } else {
          this.$message.error(res.message);
        }
      })
    },
    queryParkLotBoxInfo() {
      queryParkLotBoxInfo({SentryId: this.sentryId}).then(res => {
        if (res.state === "success") {
          this.boxData = res.data.map(v => {
            v.OnlineStateStr = v.OnlineState ? '在线' : '离线';
            v.ParkLotGateNameArr = v.ParkLotGateName.split(',');
            // console.log(v.ParkLotGateNameArr[0])
            return v
          });
        } else {
          this.$message.error(res.message);
        }
      })
    },
    queryCamFactory() {
      queryCamFactory().then(res => {
        this.factoryOptions = res.data;
      })
    },
  },
};
</script>

<style>
.search-table-top {
  text-align: center;
  line-height: 2;
  margin-bottom: 20px;
}
</style>
